var React = require('react');

function MWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"white","d":"M41.2,38.1h-3.2v-8l0,0c0-2.6-2.1-4.8-4.8-4.8c-2.6,0-4.8,2.1-4.8,4.7v1.6h-3.2V30l0,0l0,0l0,0c0-2.6-2.1-4.8-4.8-4.8c-2.6,0-4.8,2.1-4.8,4.8l0,0v1.6h-3.2V15.9h3.2v8c1.3-1,3-1.6,4.8-1.6c2.6,0,4.9,1.2,6.4,3.2c1.5-1.9,3.8-3.2,6.4-3.2c4.4,0,8,3.6,8,8l0,0V38.1z M41.2,19h-8l0,0c-2.2,0-4.1-0.9-5.6-2.3l2.3-2.3c0.9,0.8,2,1.3,3.3,1.3h8V19zM27,3.2c13.2,0,23.8,10.7,23.8,23.8S40.2,50.8,27,50.8S3.2,40.2,3.2,27S13.8,3.2,27,3.2 M27,0C12.2,0,0,12.1,0,27c0,14.8,12.1,27,27,27c14.8,0,27-12.1,27-27C54,12.2,41.8,0,27,0L27,0z"}));
}

MWhite.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"54px","height":"54px","viewBox":"0 0 54 54","xmlSpace":"preserve"};

module.exports = MWhite;

MWhite.default = MWhite;
